module.exports = __webpack_public_path__ + "img/wy2.ca21be4e.png";